const CloseButton = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute top-4 right-4 bg-gray-800 text-white rounded-full p-1 hover:bg-gray-700 transition"
      title="Close"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  );

  export default CloseButton